import React from 'react';

function Logo(props) {
  return <img alt="Skólamatur" src="/static/logo-white.svg" {...props} />;
}

export default Logo;
